import React from "react";
import Image from "next/image";

export type PalmaresBlockProps = {
  titre: string;
  placement?: string;
  imageCompetition: string;
};

const PalmaresBlock: React.FC<PalmaresBlockProps> = ({ titre, placement, imageCompetition }) => {
  return (
    <div id="palmares-block-container" className="card flex min-h-max min-w-full flex-col items-center justify-center overflow-hidden">
      {imageCompetition && (
        <div
          id="palmares-block-image-container"
          className="relative mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-whiteAccent/90 text-center text-3xl"
        >
          <div id="palmares-block-image" className="relative h-8 w-8 object-contain">
            <Image
              src={imageCompetition}
              layout="fill"
              alt={`Photo de ${titre}`}
              title={`Photo de ${titre}`}
              placeholder="blur"
              blurDataURL={imageCompetition}
              objectFit="contain"
            />{" "}
          </div>
        </div>
      )}

      <h3 id="palmares-block-titre-compet" className="mb-2 text-center text-xs font-medium uppercase leading-5 lg:text-sm">
        {titre}
      </h3>
      {placement && (
        <p
          id="palmares-block-placement"
          className="rounded-full bg-redAccent px-2 text-xs font-semibold uppercase tracking-widest text-whiteAccent lg:text-sm"
        >
          {placement}
        </p>
      )}
    </div>
  );
};

export default PalmaresBlock;
